module.exports = __webpack_public_path__ + "img/sMrHippo_350x350.f8507998.jpg";